var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.qr,"max-width":"120"}})
}
var staticRenderFns = []

export { render, staticRenderFns }